import React, {Fragment} from 'react';
import block from 'bem-cn-lite';

import {getNavigationTitleLink} from 'units/navigation/utils';
import {ItemsProps, NavigationSectionType} from 'units/navigation/models';
import {FEATURED} from 'units/services/constants';

import NavigationItemsTitle from '../NavigationItemsTitle/NavigationItemsTitle';
import ListS from 'units/navigation/components/NavigationItems/ListS/ListS';
import ListM from 'units/navigation/components/NavigationItems/ListM/ListM';

import './Items.scss';

const b = block('items');

interface ItemsOwnProps {
    type: NavigationSectionType;
}

const Items: React.FC<ItemsOwnProps & ItemsProps> = ({
    categories,
    location,
    type,
    size,
    dataByCategory,
}) => (
    <Fragment>
        {categories.map((category) => {
            const {slug} = category;

            //slider has its own title
            const shouldRenderTitle = !(slug === FEATURED && size === 'm');

            const categorizedItems = dataByCategory[slug];

            if (!categorizedItems || !categorizedItems.length) {
                return null;
            }

            const url =
                location === 'popup' ? getNavigationTitleLink(slug, type, 'category') : undefined;

            return (
                <div className={b({size})} key={slug}>
                    {shouldRenderTitle && (
                        <NavigationItemsTitle {...category} url={url} size={size} />
                    )}

                    <div className={b('wrapper')}>
                        {size === 's' ? (
                            <ListS
                                navigationItems={categorizedItems}
                                location={location}
                                type={type}
                                size={size}
                            />
                        ) : (
                            <ListM
                                category={category}
                                navigationItems={categorizedItems}
                                type={type}
                            />
                        )}
                    </div>
                </div>
            );
        })}
    </Fragment>
);

export default Items;
